// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"DashboardContainer_dashboardContainer__ux4kM"};